export const getters = {
  uid (state) {
    return state.uid
  },
  upgradeOrDowngrade(state){
    return (v) => {
      // free   - free
      // 25/mo  - plan_GFHyeVllPW1MHo
      // 150/mo - plan_G91cFxeIzg5lCq
      const plans = ['free', 'plan_GFHyeVllPW1MHo', 'plan_G91cFxeIzg5lCq']
      const i1 = plans.indexOf(state.companyPlan)
      const i2 = plans.indexOf(v)
      return i2 < i1 ? 'downgrade' : i1 == i2 ? 'current plan' : 'upgrade'
    }
  },
  popupExportProjectData (state) {
    return state.popupExportProjectData
  },

  popupTooManyProjects (state) {
    return state.popupTooManyProjects
  },

  popupDeleteProject (state) {
    return state.popupDeleteProject
  },

  emailVerified (state) {
    emailVerified: state.emailVerified
  },

  userData (state) {
    var data = {
      fullName: state.fullName,
      email: state.email,
      emailVerified: state.emailVerified,
      verificationKey: state.verificationKey,
      company: state.company,
      myCompany: state.myCompany,
      phone: state.phone,
      address: state.address,
      city: state.city,
      country: state.country,
      province: state.province,
      profileImage: state.profileImage,
      postalCode: state.postalCode,
      companyName: state.companyName,
      companyWebsite: state.companyWebsite,
      companyType: state.companyType,
      companyRate: state.companyRate,
      companyContingency: state.companyContingency,
      companyCost: state.companyCost,
      companyImage: state.companyImage,
      companyPhone: state.companyPhone,
      companyAddress: state.companyAddress,
      companyCity: state.companyCity,
      companyCountry: state.companyCountry,
      companyProvince: state.companyProvince,
      companyPostalCode: state.companyPostalCode
    }
    return data
  },

  selectedPriceRange (state) {
    return state.selectedPriceRange
  },

  tokenData (state) {
    return state.tokenData
  },

  popupProject (state) {
    return state.popupProject
  },

  projectTemplates (state) {
    return state.projectTemplates
  },

  globalPopup (state) {
    return state.popupOn
  },

  myCompany (state) {
    return state.myCompany
  },

  billingID (state) {
    return state.billingID
  },

  companyPlan (state) {
    return state.companyPlan
  },

  companyTasks (state) {
    return state.companyTasks
  },

  showPricesPrices (state) {
    return state.showPricesPrices
  },

  showCalculator (state) {
    return state.showCalculator
  },

  showPricesComments (state) {
    return state.showPricesComments
  },

  showPricesHours (state) {
    return state.showPricesHours
  },

  emailVerified (state) {
    return state.emailVerified
  },

  verificationKey (state) {
    return state.verificationKey
  },

  authError (state) {
    return state.authError
  },

  currentProjectFull (state) {
    return state.currentProjectFull
  },

  currentProjectRate (state) {
    return state.currentProjectRate
  },

  currentProjectCost (state) {
    return state.currentProjectCost
  },
  companyContingency (state) {
    return state.companyContingency
  },

  companyRate (state) {
    return state.companyRate
  },

  currentProjectPhases (state) {
    return state.currentProjectPhases
  },

  currentProjectComments (state) {
    return state.currentProjectComments
  },

  currentProjectName (state) {
    return state.currentProjectName
  },

  currentProjectContingency (state) {
    return state.currentProjectContingency
  },

  currentProjectModules (state) {
    return state.currentProjectModules
  },

  currentProjectOverrides (state) {
    return state.currentProjectOverrides
  },

  currentProjectModuleColumns (state) {
    return state.currentProjectModuleColumns
  },

  afterEmailRecovery (state) {
    return state.afterEmailRecovery
  },

  loading (state) {
    return state.loading
  },

  myProjectList (state) {
    return state.myProjects
  },

  myProjectListWithDetails (state) {
    return state.myProjectDetails
  },

  myProjectListWithDetailsFull (state) {
    return state.myProjectDetailsFull
  },

  myProjectVersions (state) {
    return state.myProjectDetailsFull
  },

  newsArticles (state) {
    return state.newsArticles
  },

  companyName (state) {
    return state.companyName
  },
  selectedCell (state) {
    return state.selectedCell
  },
  editingCell (state) {
    return state.editingCell
  },
  backupPosition (state) {
    return state.backupPosition
  },
  undoCount (state) {
    return state.undoCount
  },
  fromUndo (state) {
    return state.fromUndo
  },
  projectBackup (state) {
    return state.projectBackup
  },
  userRole (state) {
    return state.userRole
  },
  isLoading (state) {
    return state.isLoading
  },
  redirectUrl(state) {
    return state.redirectUrl
  }
}
